import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import Schedule from '../Schedule';
import formatTimeRange from '../../utils/formatTimeRange';
import useLanguage from '../../hooks/useLanguage';

const Hours = ({ departmentsAndHours }) => {
  const { t } = useTranslation();
  const lang = useLanguage();
  const today = new Date();
  const currentDayOfWeek = today.getDay();
  const departmentHoursMap = departmentsAndHours
    ?.map(department => {
      const timeData = department?.hours?.find(item => item.dayOfWeek === currentDayOfWeek) || {};
      const { start, end } = timeData;
      const time = formatTimeRange(start, end, lang, t);
      return {
        title: t(`Sub-apps.Dealers.${department?.type}Label`),
        time,
      };
    })
    .filter(departmentItems => departmentItems.time !== t('Sub-apps.Dealers.closedLabel'));

  return <Schedule dataTestId="cy-dealer-card-departments-hours" items={departmentHoursMap} />;
};

Hours.propTypes = {
  departmentsAndHours: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      contactInformation: PropTypes.shape({
        email: PropTypes.string,
        fax: PropTypes.string,
        phone: PropTypes.string,
        website: PropTypes.string,
      }),
      hours: PropTypes.arrayOf(
        PropTypes.shape({
          hours: PropTypes.arrayOf(
            PropTypes.shape({
              start: PropTypes.string,
              end: PropTypes.string,
              dayOfWeek: PropTypes.number,
              dayOfWeekName: PropTypes.string,
            }),
          ),
        }),
      ),
    }),
  ),
};

export default Hours;
